namespace('compass.hotel');

compass.require('compass.hotel.StarRatingWidget');
compass.requireLib('compass.util.format');

compass.hotel.HotelCardWidget = compass.defineWidget(function HotelCardWidget(options) {
	var me = this;
	var d = jQuery.dom;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _hotel = _settings.hotel;
	var _reservations = _settings.reservations;
	var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";
	var _ids = {
		hotelName: compass.generateId()
	};
	
	// lowestAvgRateNumeric will === -1 only in the case that eps returned no availability for a hotel
	// In that case disable the display of most of the things on the card
	if (_hotel.avail !== undefined && _hotel.avail.lowestAvgRateNumeric < 0) {
		_settings.showAverageRate = false;
		if (!_settings.meetingInfo.showSimplifiedHotelFilter) {
			_settings.displayHotelStars = false;
			_settings.hideDistance = true;
		}
	}

	var _cf = compass.util.currencyFormatter(_settings.meetingInfo.currencyCode,
		{ showDecimals : 0 });

	this.render = function(widgetElem) {
		var classes = 'hotelCard hotel_id_' + _hotel.hotelId;
		if(_hotel.hqHotel) {
			classes += ' headquartersHotel';
		}

		if(_settings.showAvailability) {
			if(_hotel.avail.status === 'SOLDOUT') {
				classes += ' soldOut';
				widgetElem.activate(function() {
					d.alert('This hotel is not available');
				});
			} else {
				widgetElem.activate(function() {
					me.trigger('HotelCard.hotelClicked', {
						hotel : _hotel,
						avail : _hotel.avail
					});
				});
			}
		}

		var roomsBookedLabel = '';
		if(_reservations.length) {
			var numberOfRooms = _.foldl(_reservations, function(acc, reservation) {
				return acc + reservation.numberOfRooms;
			}, 0);
			roomsBookedLabel = numberOfRooms + (numberOfRooms == 1 ? ' Room Booked' : ' Rooms Booked');
			classes += ' hasRoomsBooked';
		}

		
		var headquartersText = 'HQ';
		if (_settings.meetingInfo.showSimplifiedHotelFilter) {
			classes += ' simplified';
			headquartersText = 'Headquarters Hotel';
		}

		widgetElem.append(
			d.div({ className : classes, tabindex : 0, 'role': 'button', 'aria-role' : 'button', 'aria-labelled': _ids.hotelName },
				me.drawSoldOut(_hotel),
				d.div( {className: 'hotelCardContent'},
					d.div({ className : 'markers' },
						d.div({ className : 'roomsBooked marker' }, roomsBookedLabel),
						d.div({ className : 'headquarters marker' }, d.abbr({title: 'Headquarters'}, headquartersText) ),
						d.div({ className : 'clear' })
					),
					me.drawHotelName(_hotel),
					me.drawHotelImg(_hotel),
					(_settings.showAverageRate) ? d.div( {className: 'rateWrapper'}, me.drawRates(_hotel) ) : null,
					me.drawFooter(_hotel, _settings.availMin)
				)
			)
		);
	};

	this.getHotel = function() {
		return _hotel;
	};

	this.drawFooter = function(hotel, availMin) {
		var starRatingDisplay;
		if(hotel.starRatingDecimal){
			starRatingDisplay = hotel.starRatingDecimal;
		} else {
			starRatingDisplay = hotel.starRating;
		}
		return d.div({ className : 'cardFooter' },
			_settings.showAvailability ? me.drawAvailability(_hotel, availMin) : me.drawTotalRooms(_hotel),
			d.div({className: 'inlineDistanceAndOrRating'},
				!_settings.hideDistance && me.drawDistance(_hotel),
				_settings.displayHotelStars && starRatingDisplay > 0 && me.drawHotelStarRating(_hotel, starRatingDisplay)
			)
		);
	};

	this.drawSoldOut = function(hotel) {
		var className = 'soldOutWrapper';
		if(!_settings.displayHotelStars) {
			className += ' noStars';
		}
		return d.div({ className : className },
			d.div({ className: 'soldOutMessage' }, _settings.labels.soldOut)
		);
	};

	this.drawRates = function(hotel) {
		var price;
		if(_settings.showAvailability) {
			var priceTBD = d.abbr({ title : 'Price - to be determined' }, 'TBD');
			var avgRate = hotel.avail.showInclusiveLowestAvgRate ? (hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) : hotel.avail.lowestAvgRateNumeric;
			price = avgRate === 0 ? priceTBD : _cf(Math.round(avgRate));
		} else {
			price = _cf(Math.round(hotel.avgRate));
		}

		if (_settings.meetingInfo.priceSavingsPercent && hotel.avail.status !== 'SOLDOUT') {
			var compareAtPrice = Math.round(hotel.avail.lowestAvgRateNumeric / (1.0 - _settings.meetingInfo.priceSavingsPercent ));
		
			var priceSavingsDOM = d.div({className: 'priceSavingsText'}, 
				d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-solid fa-dollar-circle'})), 
				"Normally " + _settings.meetingInfo.currencySymbol + compareAtPrice
			);
		}

		if (typeof(price) !== 'object') {
			price = price + ((hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric ? '*' : '');
		}

		var rateMsg = ((hotel.avail.inclusiveLowestAvgRateNumeric || hotel.avail.lowestAvgRateNumeric) != hotel.avail.lowestAvgRateNumeric ? d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes mandatory hotel fee'))  : null);
		if (hotel.avail.isServiceFeeIncluded === true) rateMsg = d.div({className:'ratedesc'},d.abbr({className : 'includesResortFee'},'*Rate includes onPeak service fee.'));

		return d.div({ className : "rate" },
			price,
			d.div({ className : 'ratedesc' },
				d.span({ 'aria-hidden' : true }, _settings.meetingInfo.currencyCode),
				' | ',
				d.abbr({ title : 'Average per night' }, 'avg/night'),
				d.reader('.')
			),
			rateMsg,
			_settings.displayPriceSavings && priceSavingsDOM
		);
	};

	this.drawHotelImg = function(hotel) {
		var mainImage = hotel.images.main;
		var src = _defaultImage;
		if(mainImage && mainImage.imagePath.length > 0) {
			src = mainImage.imagePath;
		}
		var retryCount = 0;
		var imgElement = d.img({ className : "hotelImg", src : src, alt : '' });
		imgElement.on('error', function() {
			// just in case _defaultImage produces an error too, prevent infinite loop
			if (retryCount < 5) {
				brokenSrc = imgElement.attr('src');
				if (_settings.meetingInfo.trackHotelImageErrors) {
					var filterResults = _.filter(
						["FAKE_IMG_URL", "nomainimage"],
						function(keyword) {
							return brokenSrc.indexOf(keyword) > -1;
						}
					);
					// only log the error if the URL didnt match any of the filter keywords/phrases
					if (filterResults.length === 0) {
						eventData = {
							hotel_id: hotel.hotelId,
							image_url: brokenSrc
						};
						// log the broken URL to Keen
						jQuery.ajax({
							url : '/sendToKeen',
							type: 'POST',
							ignoreTimeout : true,
							data: JSON.stringify({ 'stream': 'compass_hotelImageError', eventData: eventData }),
							dataType: 'json',
							error: function(event) {} //If call fails, suppress
						});
					}
				}
				imgElement.attr('src', _defaultImage);
				retryCount++;
			}
		});
		return imgElement;
	};

	this.drawHotelName = function(hotel) {
		return d.div({ className : "hotelNameWrapper" },
			d.reader(d.p({id:  _ids.hotelName}, hotel.name)),
			d.middled(d.p({ className : "hotelName", 'aria-hidden' : 'true' }, hotel.name))
		);
	};

	this.drawHotelStarRating = function(hotel, starRatingDisplay) {
		var starRatingDOM = d.div({ className : "hotelStarRating" }, d.div({className: 'label'}, "rating"));
		var _starRatingWidget = new compass.hotel.StarRatingWidget(starRatingDOM, {
			WUID : 'StarRatingWidget_' + _WUID,
			stars : (hotel.status === 'SOLDOUT' ? 0 : starRatingDisplay )
		});
		return starRatingDOM;
	};

	this.drawDistance = function(hotel) {
		return d.div({ className: 'hotelDistance'}, 
				d.div({className: 'label'}, "distance"),
				d.div({},  	d.span({ className : "hotelDistanceVal" }, Number(hotel.distance).toFixed(1)),
							d.span('&nbsp;'),
							d.span({ className : "hotelDistanceUnit"}, hotel.distanceUnits)
				)
		);
	};

	
	
	function getAvailabilityMessage(hotel, availMin){
		var availMessage = '';
		var availMin = availMin || 0;
		
		if ( _settings.hideNumberOfRoomsAvailable === true ){
			return "&nbsp;";
		}
		
		if(hotel.avail.status == 'GDS' || (hotel.avail != undefined && hotel.avail.lowestAvgRateNumeric < 0)) {
			availMessage = _settings.labels.availGds;
		} else if( availMin > hotel.avail.maxOneBlockReservations && availMin <= hotel.avail.maxMultiBlockReservations) {
			availMessage = _settings.labels.availLimited;
		}
		else if(availMin <= hotel.avail.maxOneBlockReservations){
			availMessage = 'Up to ' + hotel.avail.maxMultiBlockReservations +
					(hotel.avail.maxMultiBlockReservations === 1 ? ' room' : ' rooms') + ' available';
		}
		return availMessage;
	}

	this.drawAvailability = function(hotel, availMin) {
		var availMin = availMin || 0;
		var hotelStatus = hotel.status;
		return d.div({ className : 'hotelAvailability' }, getAvailabilityMessage(hotel, availMin));
	};

	this.drawTotalRooms = function(hotel) {
		return d.div({ className : 'hotelTotalRooms' },
			d.span({className: 'totalRoomsValue'}, hotel.totalRooms), _settings.labels.totalRoomsReserved
		);
	};

	this.setData = function(hotel){
		_hotel = hotel;
	};

	this.redraw = function(hotel, availMin){
		var availMin = availMin || 0;
		this.setData(hotel);
		
		// redraw the rate
		var rateWrapper = me.find('.rateWrapper');
		rateWrapper.empty();
		rateWrapper.append(me.drawRates(hotel));

		// redraw the availability message
		me.find('.hotelAvailability').text(getAvailabilityMessage(hotel, availMin));
	};

	this.updateTotalRooms = function(totalRooms) {
		me.find('.hotelTotalRooms .totalRoomsValue').empty().append(totalRooms);
	};

}, {
	WUID : 'defaultHotelCardWidgetWUID',
	widgetName : 'HotelCardWidget',
	reservations : [ ],
	displayHotelStars : true,
	meetingInfo : {},
	availMin : 0,
	showAvailability : true,
	showAverageRate: true,
	displayPriceSavings: false,
	hideNumberOfRoomsAvailable : false,
	labels : {
		soldOut : 'UNAVAILABLE',
		availGds : 'Check Availability',
		availLimited : 'Limited Availability',
		totalRoomsReserved : ' Rooms Reserved'
	}
});

